import './ErrorsPages.scss';

import { ArrowForward} from '@mui/icons-material';
import { Button } from '@mui/material';
import {useNavigate } from 'react-router-dom';

import { DrawIconsError404 } from '../../data/SVGs';
//import useRole from '../hooks/useRole';
import { buttonStylesBlue } from '../docsAdministrative/JsObjectStyles';
//import Footer from './shared/Footer/Footer';
//import NavbarHome from './shared/Navbar/NavbarHome';

const Error404 = () => {

    const navigate = useNavigate();
    //const role=useRole();

    return (
        //<article style={{width:'100%'}}>
        <div
            className='App-intro'
            style={{height:'100%'}}
        >
            {/*<NavbarHome />*/}
            <div className='errorF0'>
                <DrawIconsError404 />
                <div className='errorF1'>
                    <h5
                        className='pricingF25'
                        style={{color:'#272D3C'}}
                    >Ooops...Something Went Wrong!</h5>
                    <h6
                        className='pricingF26'
                        style={{color:'#B0B0B0'}}
                    >Sorry, the page you requested could not be found</h6>
                </div>
                <div className="flexGrow">
                    <div className="flexGrow">
                        <Button
                            variant='contained'
                            onClick={()=>{
                                //navigate(`/${role}/`,{replace:true});
                                navigate(-1);
                            }}
                            style={{...buttonStylesBlue()}}
                            startIcon={<ArrowForward />}
                        >Retour</Button>
                    </div>
                </div>
            </div>
            {/*<Footer />*/}
        </div>
        //</article>
    );
};

export default Error404;
